import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_PathwayState, DBDef_PathwayState } from '@app/pathway-shared';
import { ModuleFE_Expression } from '@app/hcs-frontend';
import { ModuleFE_PathwayTransition } from '../pathway-transition/index.js';
export const dispatch_onPathwayStateChanged = new ThunderDispatcherV3('__onPathwayStateUpdated');
export class ModuleFE_PathwayState_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PathwayState, dispatch_onPathwayStateChanged);
        this._v1 = {
            deletePathwayState: apiWithBody(ApiDef_PathwayState._v1.deletePathwayState, this.onDeletePathwayStateComplete),
            detachStateContext: apiWithBody(ApiDef_PathwayState._v1.detachStateContext, this.onDetachPathwayState)
        };
    }
    onDetachPathwayState = async (res) => {
        await this.onEntriesUpdated(res.pathwayStates);
        if (res.pathwayTransitions.deleted.length)
            await ModuleFE_PathwayTransition.onEntriesDeleted(res.pathwayTransitions.deleted);
        if (res.pathwayTransitions.updated.length)
            await ModuleFE_PathwayTransition.onEntriesUpdated(res.pathwayTransitions.updated);
        if (res.resolutionFunctions.deleted.length)
            await ModuleFE_Expression.onEntriesDeleted(res.resolutionFunctions.deleted);
        if (res.resolutionFunctions.updated.length)
            await ModuleFE_Expression.onEntriesUpdated(res.resolutionFunctions.updated);
    };
    onDeletePathwayStateComplete = async (response) => {
        if (response.removedPathwayTransitions.length)
            await ModuleFE_PathwayTransition.onEntriesDeleted(response.removedPathwayTransitions);
        if (response.updatedPathwayTransitions.length)
            await ModuleFE_PathwayTransition.onEntriesUpdated(response.updatedPathwayTransitions);
        if (response.removedResolutionFunctions.length)
            await ModuleFE_Expression.onEntriesDeleted(response.removedResolutionFunctions);
        if (response.removedPathwayStates?.length)
            return await this.onEntriesDeleted(response.removedPathwayStates);
        // I can assume this exists cause it's either deleted or updated
        await this.onEntriesUpdated(response.updatedPathwayStates);
    };
}
export const ModuleFE_PathwayState = new ModuleFE_PathwayState_Class();
//# sourceMappingURL=ModuleFE_PathwayState.js.map